// extracted by mini-css-extract-plugin
export default {"comments-feed-right-side":"CommentsFeedRightSide_comments-feed-right-side__AP2tS"};